module.exports = __webpack_public_path__ + "static/media/OpenSans SemiBold-01.14e48723.svg";